import store from './store'
import { AUser, ALogin } from 'kuaidong-api'
import { Organization, UserTeacherId } from 'kuaidong-model'
import { Module, getModule, VuexModule, Mutation, MutationAction } from 'vuex-module-decorators'

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'login',
})
class LoginModule extends VuexModule {
  organization: Organization | null = null

  userTeacherId: UserTeacherId | null = null

  get isAuthed() {
    return !!this.userTeacherId?.teacher_id
  }

  get isLogined() {
    return !!this.userTeacherId?.user_id
  }

  get isLoginedByOrganization() {
    return !!this.organization
  }

  get userId() {
    return this.userTeacherId?.user_id || ''
  }

  get teacherId() {
    return this.userTeacherId?.teacher_id || ''
  }

  @Mutation
  reset() {
    this.organization = null
    this.userTeacherId = null
  }

  @MutationAction
  async loadUserTeacherId() {
    const userTeacherId = await AUser.loginByH5Token()

    return { userTeacherId, organization: null as any }
  }

  @MutationAction
  async loadOrganization() {
    const organization = await ALogin.getOrganizationInfo()

    return { organization, userTeacherId: { user_id: organization.id, teacher_id: organization.id } as UserTeacherId }
  }
}

export default getModule(LoginModule)
